import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal';
import TransferCreatorCredentialsModal from './TransferCreatorCredentialsModal';
import { closeCompanyDashboardModals } from '../../../../store/actions/companyActions';

class TransferCreatorCredentialsAll extends Component {
    constructor(props) {
        super()

        this.state = {
            transferMemberRole: "",
            memberNameForSearch: "",
            employeeMapJson: null,
            showTransferConfirmModal: false,
        }
    }

    /// README: TO BE SEARCH ENTRY
    handleSearch = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    /// README: SEARCH STRING VALIDITY CHECK
    //      (return true if "" and " " is not entered as first character)
    checkValidSearch = () => {
        const { transferMemberRole } = this.state;
        return (transferMemberRole === "" || transferMemberRole.startsWith(" ")) === false;
    }

    /// README: FILTERS THE accessMap BY SEARCH STRING
    filterBySearch = (s) => {
        const { transferMemberRole } = this.state;
        var sname = `${s.name}`;
        return sname.toLowerCase().startsWith(transferMemberRole.toLowerCase());
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num, employeeMapJson) => {
        switch (num) {
            case 0: {
                this.setState({ showTransferConfirmModal: true, employeeMapJson });
                break;
            }
            default: {
                this.setState({ showTransferConfirmModal: false });
                break;
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showTransferConfirmModal: false });
                break;
            }
            default: {
                this.setState({ showTransferConfirmModal: false });
                break;
            }
        }
    }

    componentDidMount() {
        this.setState({
            transferMemberRole: this.props.transferMemberRole,
        });
    }

    render() {
        const { companyData, modalTitleStyle, modalStyles, modalWidthMedium, alu, company, commons, modalInfoTextStyle } = this.props;
        const { accessMap } = companyData;
        const { isModalCalled } = company;

        return (
            <React.Fragment>
                <div className="dynamicModalContainer">
                    <div className="dynamicModalSm">
                        <h5 style={modalTitleStyle}>Transfer creator credentials</h5>
                        <p style={modalInfoTextStyle}>You can grant yourself admin access to any of the company's {commons.project}.</p>
                        <input type="text" className="form-control" id="transferMemberRole" placeholder="Search for a member" onChange={this.handleSearch} defaultValue={this.state.transferMemberRole} />
                        <div style={{ maxHeight: '400px', overflow: 'auto', marginTop: '10px' }}>
                            {'accessMap' in companyData ? Object.keys(companyData.accessMap).length !== 0 ? this.checkValidSearch() ? Object.values(companyData.accessMap).filter(this.filterBySearch).map((val, i) => {
                                var mueid = val.uid + val.employeeid;
                                var memberAccessLevel = accessMap ? mueid in accessMap ? accessMap[mueid]['access'] : alu.invalid : alu.invalid;
                                return (
                                    <div key={i}>
                                        <li className="card p-2 m-2" style={{ borderRadius: '10px' }}>
                                            <div className="d-flex" >
                                                <div className="p-2 flex-fill" style={{ fontWeight: "bold" }}>{val.name}
                                                    <br />
                                                    <p className="badge badge-pill px-3" style={{ backgroundColor: `${alu.color[memberAccessLevel]}`, color: `${alu.textColor[memberAccessLevel]}`, textAlign: "start", fontSize: "10px", fontStyle: "italic" }}>
                                                        {alu.text[memberAccessLevel]}</p>
                                                </div>
                                                <div className="p-2 flex-fill">
                                                    <div className="btn btn-outline-danger btn-sm float-right" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(0, val); this.props.closeCompanyDashboardModals() }}>Transfer</div>
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                )
                            }) : '' : 'No member found' : 'No member found'}
                        </div>

                    </div>
                </div>

                {/* TRANSFER CREDENTIALS CONFIRM MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showTransferConfirmModal && !isModalCalled === true}
                    onRequestClose={() => { this.handleCloseModal(0) }}
                    contentLabel="Transfer credentials"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <TransferCreatorCredentialsModal employeeMapJson={this.state.employeeMapJson} />
                </ReactModal>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        companyData: state.firestore.data.Company,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        company: state.company,
        commons: state.commons,

        // styles
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,

    }
}

const mapDispatchTpProps = (dispatch) => {
    return {
        closeCompanyDashboardModals: () => dispatch(closeCompanyDashboardModals()),
    }
}


export default connect(mapStateToProps, mapDispatchTpProps)(TransferCreatorCredentialsAll)
